(function () {
  if (window.TroopCarePackageCheckout) return;

  const CARE_PACKAGE_HANDLE = 'operation-blackout-care-package';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let checkoutValidationInFlight = false;

  function cartUrl(path) {
    return `${root}${path}`.replace(/\/+/g, '/');
  }

  async function requestJson(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
    return response.json();
  }

  function isCarePackage(item) {
    return item && item.handle === CARE_PACKAGE_HANDLE;
  }

  function hasMixedCarePackageCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    const hasCarePackage = cart.items.some(isCarePackage);
    const hasOtherItems = cart.items.some((item) => !isCarePackage(item));
    return hasCarePackage && hasOtherItems;
  }

  function setStatus(container, message, includeCartLink) {
    const status = container && container.querySelector('[data-troop-checkout-status]');
    if (!status) return;

    status.replaceChildren();
    status.hidden = !message;
    if (!message) return;

    status.append(document.createTextNode(message));
    if (includeCartLink) {
      status.append(document.createTextNode(' '));
      const link = document.createElement('a');
      link.href = cartUrl('cart');
      link.textContent = 'Review your cart';
      status.append(link);
    }
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    const label = button.querySelector('[data-troop-checkout-label]') || button;

    if (loading) {
      button.dataset.troopOriginalLabel = label.textContent.trim();
      label.textContent = 'Preparing checkout…';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      return;
    }

    if (button.dataset.troopOriginalLabel) {
      label.textContent = button.dataset.troopOriginalLabel;
      delete button.dataset.troopOriginalLabel;
    }
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }

  function getQuantity(container) {
    const input = container.querySelector('[name="quantity"]');
    const quantity = Number.parseInt(input && input.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getVariantId(container, trigger) {
    const select = container.querySelector('[name="id"]');
    return Number(trigger.dataset.variantId || (select && select.value) || container.dataset.variantId || 0);
  }

  async function startExclusiveCheckout(trigger) {
    const container = trigger.closest('[data-troop-checkout]');
    if (!container) return;

    const acknowledgement = container.querySelector('[data-troop-acknowledgement]');
    if (acknowledgement && !acknowledgement.checked) {
      setStatus(container, 'Please confirm that this care package will be sent to deployed troops.', false);
      acknowledgement.focus();
      return;
    }

    const variantId = getVariantId(container, trigger);
    const productId = Number(container.dataset.productId || 0);
    const quantity = getQuantity(container);

    if (!variantId || !productId) {
      setStatus(container, 'The care package is temporarily unavailable. Please refresh and try again.', false);
      return;
    }

    setStatus(container, '', false);
    setButtonLoading(trigger, true);

    try {
      const cart = await requestJson(cartUrl('cart.js'));
      const containsOtherItems = cart.items.some((item) => Number(item.product_id) !== productId);

      if (containsOtherItems) {
        setStatus(
          container,
          'The care package must be purchased separately from products being shipped to you.',
          true
        );
        return;
      }

      await requestJson(cartUrl('cart/clear.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });

      await requestJson(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: { _troops_only: 'true' },
            },
          ],
        }),
      });

      window.location.assign(cartUrl('checkout'));
    } catch (error) {
      console.error('Care package checkout failed', error);
      setStatus(container, 'We could not prepare checkout. Please try again.', false);
    } finally {
      setButtonLoading(trigger, false);
    }
  }

  function showMixedCartWarning() {
    window.alert(
      'The Operation Blackout Care Package must be purchased separately from products being shipped to you. Please remove either the care package or the other products before checkout.'
    );
  }

  async function validateStandardCheckout(control) {
    if (checkoutValidationInFlight) return;
    checkoutValidationInFlight = true;

    try {
      const cart = await requestJson(cartUrl('cart.js'));
      if (hasMixedCarePackageCart(cart)) {
        showMixedCartWarning();
        return;
      }

      window.location.assign(control.href || cartUrl('checkout'));
    } catch (error) {
      console.error('Care package cart validation failed', error);
      window.alert('We could not validate your cart. Please refresh and try again.');
    } finally {
      checkoutValidationInFlight = false;
    }
  }

  document.addEventListener('click', function (event) {
    const productQuantityButton = event.target.closest('.js-qty__adjust--plus, .js-qty__adjust--minus');
    const productQuantityContainer = productQuantityButton && productQuantityButton.closest('[data-troop-checkout]');
    if (productQuantityContainer) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const input = productQuantityContainer.querySelector('[name="quantity"]');
      if (!input) return;
      const change = productQuantityButton.classList.contains('js-qty__adjust--plus') ? 1 : -1;
      input.value = Math.max(1, getQuantity(productQuantityContainer) + change);
      return;
    }

    const quantityButton = event.target.closest('[data-troop-quantity-change]');
    if (quantityButton) {
      const container = quantityButton.closest('[data-troop-checkout]');
      const input = container && container.querySelector('[name="quantity"]');
      if (!input) return;
      const nextQuantity = Math.max(1, getQuantity(container) + Number(quantityButton.dataset.troopQuantityChange || 0));
      input.value = nextQuantity;
      return;
    }

    const dialogOpen = event.target.closest('[data-troop-dialog-open]');
    if (dialogOpen) {
      const section = dialogOpen.closest('[data-ob-section]');
      const dialog = section && section.querySelector('[data-troop-dialog]');
      if (dialog) dialog.showModal();
      return;
    }

    const dialogClose = event.target.closest('[data-troop-dialog-close]');
    if (dialogClose) {
      const dialog = dialogClose.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    const trigger = event.target.closest('[data-troop-checkout-trigger]');
    if (trigger) {
      event.preventDefault();
      startExclusiveCheckout(trigger);
      return;
    }

    const checkoutControl = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!checkoutControl || checkoutControl.dataset.troopCheckoutBypass === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    validateStandardCheckout(checkoutControl);
  }, true);

  document.addEventListener('change', function (event) {
    const acknowledgement = event.target.closest('[data-troop-acknowledgement]');
    if (!acknowledgement) return;

    const container = acknowledgement.closest('[data-troop-checkout]');
    const trigger = container && container.querySelector('[data-troop-checkout-trigger]');
    if (!trigger || trigger.dataset.troopUnavailable === 'true') return;

    trigger.disabled = !acknowledgement.checked;
    if (acknowledgement.checked) setStatus(container, '', false);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    validateStandardCheckout(submitter);
  }, true);

  document.addEventListener('click', function (event) {
    const dialog = event.target.closest('[data-troop-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  window.TroopCarePackageCheckout = { hasMixedCarePackageCart };
})();
